import React from 'react';
import { Link } from 'gatsby';
import { SmallArticleCard } from '../../Cards/SmallArticleCard';
import styles from './SmallPostsList.styles';

const SmallPostsList = ({ posts, lastElement = true }) => (
  <div className="small-post-list" css={styles}>
    {posts.map((post, index, self) => {
      if (!lastElement && index === self.length - 1) return null;

      return (
        <Link to={post.href} key={post.href} className="small-post-list__navigation-link">
          <SmallArticleCard
            backgroundColor={post.backgroundColor}
            image={post.image}
            mobileImage={post.mobileImage}
            header={post.description}
            logo={post.logo}
          />
        </Link>
      );
    })}
  </div>
);

export default SmallPostsList;
